export const ROLES = [
  "Founder / CEO", "CTO", "VP Engineering", "Engineering Manager",
  "Staff / Principal Engineer", "Software Engineer", "Product Leader",
  "AI / ML Lead", "Data Scientist", "Researcher", "Designer",
  "Investor", "Advisor", "Student", "Other",
];

export const SENIORITY = ["IC", "Lead", "Manager", "Director", "VP", "C-level", "Founder"];

export const COMPANY_STAGES = [
  "Pre-seed / Idea", "Seed", "Series A", "Series B–C", "Growth / Late",
  "Public", "Enterprise", "Agency / Consultancy", "Solo / Independent",
];

export const INDUSTRIES = [
  "Artificial Intelligence", "Developer Tools", "Fintech", "Healthtech",
  "SaaS / B2B", "Consumer", "Robotics", "Cybersecurity", "Climate / Energy",
  "Education", "E-commerce", "Gaming", "Hardware", "Other",
];

export const EXPERTISE = [
  "LLMs & Generative AI", "Machine Learning", "MLOps", "Data Engineering",
  "Distributed Systems", "Backend", "Frontend", "Mobile", "DevOps / Infra",
  "Security", "Product Strategy", "Design / UX", "Growth & Marketing",
  "Fundraising", "Hiring & Team Building", "Leadership & Management",
  "Sales", "Operations", "Research",
];

export const GOALS = [
  "Find a co-founder", "Hire talent", "Get hired", "Learn & grow",
  "Mentor others", "Find a mentor", "Find collaborators for projects",
  "Raise funding", "Invest", "Just network",
];

export const OPEN_TO = ["Mentoring", "Being mentored", "Collaborating", "Advising", "Investing", "Co-founding"];

export const TOOLS = [
  "Python", "JavaScript / TypeScript", "React", "Node.js", "Go", "Rust",
  "PyTorch", "TensorFlow", "AWS", "GCP", "Azure", "Kubernetes", "Docker",
  "PostgreSQL", "MongoDB", "LangChain", "OpenAI API", "Hugging Face",
];
